import { defineComponent as p, openBlock as o, createElementBlock as e, mergeProps as u, unref as n, renderSlot as m, createElementVNode as l, createCommentVNode as g } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, f = { key: 1 }, k = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, M = {
  name: "ScalarIconDotOutline"
}, v = /* @__PURE__ */ p({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const a = s, { bind: d, weight: r } = A(a);
    return (i, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      m(i.$slots, "default"),
      n(r) === "bold" ? (o(), e("g", Z, t[0] || (t[0] = [
        l("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,128,136Z" }, null, -1)
      ]))) : n(r) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        l("path", {
          d: "M152,128a24,24,0,1,1-24-24A24,24,0,0,1,152,128Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144Z" }, null, -1)
      ]))) : n(r) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        l("path", { d: "M156,128a28,28,0,1,1-28-28A28,28,0,0,1,156,128Z" }, null, -1)
      ]))) : n(r) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        l("path", { d: "M128,98a30,30,0,1,0,30,30A30,30,0,0,0,128,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,128,146Z" }, null, -1)
      ]))) : n(r) === "regular" ? (o(), e("g", w, t[4] || (t[4] = [
        l("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144Z" }, null, -1)
      ]))) : n(r) === "thin" ? (o(), e("g", y, t[5] || (t[5] = [
        l("path", { d: "M128,100a28,28,0,1,0,28,28A28,28,0,0,0,128,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,128,148Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  v as default
};
